export const loginPage = () => `
  <section class="login-page">
    <div class="login-container">
      <div class="login-card">
        <div class="login-header">
          <img src="/logo.jpg" alt="YILDIZ360" class="login-logo">
          <h1>Giriş Yap</h1>
          <p>Hesabınıza erişmek için giriş yapın</p>
        </div>

        <form class="login-form" id="loginForm">
          <div class="form-group">
            <label for="email">Email veya Telefon</label>
            <input type="text" id="email" class="form-control" placeholder="Email veya telefon numarası" required>
          </div>

          <div class="form-group">
            <label for="sifre">Şifre</label>
            <input type="password" id="sifre" class="form-control" placeholder="Şifreniz" required>
          </div>

          <div id="loginError" class="error-message" style="display: none;"></div>

          <button type="submit" class="btn-primary btn-block">Giriş Yap</button>
        </form>

        <div class="login-footer">
          <a href="/">Ana Sayfaya Dön</a>
        </div>
      </div>
    </div>
  </section>
`;
